<template>
  <section>
    <proposta v-if="proposta" :data="proposta"/>
  </section>
</template>

<script>
import Proposta from '@/components/matriculas/simulador/Proposta.vue'
export default {
  components: {
    Proposta
  },
  data () {
    return {
      proposta: null
    }
  },
  mounted () {
    const proposta = localStorage.getItem('proposta')
    this.proposta = JSON.parse(proposta)
  }
}
</script>

<style>

</style>